import React, { FC } from 'react'

import { Card, LoadingSpinner } from '../../components'
import { LeaveOfAbsence, LeaveOfAbsenceForm } from '../../entities/LeaveOfAbsences/LeaveOfAbsences'
import { leaveOfAbsenceStatus, LeaveOfAbsenceStatusTypes } from '../../types/LeaveOfAbsenceStatusTypes'
import { EditLeaveOfAbsenceForm } from '../index'

interface LeaveOfAbsenceEditContainerProps {
    leaveOfAbsence?: LeaveOfAbsence
    isLoading: boolean
    onSubmit: (formData: LeaveOfAbsenceForm) => void
    onCancelChangeRequest?: () => void
    className?: string
}

const LeaveOfAbsenceEditContainer: FC<LeaveOfAbsenceEditContainerProps> = ({
    leaveOfAbsence,
    isLoading,
    onSubmit,
    onCancelChangeRequest,
    className = '',
}) => {
    const emptyState = ! leaveOfAbsence || Object.keys(leaveOfAbsence).length === 0

    const status = leaveOfAbsence ? leaveOfAbsence.status : {} as LeaveOfAbsenceStatusTypes
    const { color } = leaveOfAbsenceStatus[status] || {}

    if (isLoading || emptyState) {
        return <LoadingSpinner />
    }

    return (
        <div className={`leave-of-absence-edit ${className}`}>
            <Card
                color={color}
                className="leave-of-absence-edit__card"
            />

            <EditLeaveOfAbsenceForm
                leaveOfAbsence={leaveOfAbsence}
                isLoading={isLoading}
                onSubmit={onSubmit}
                onCancelChangeRequest={onCancelChangeRequest}
            />
        </div>
    )
}

export default LeaveOfAbsenceEditContainer
